<template>
    <div class="border-t border-gray-50 mt-2 pt-2"></div>
</template>

<script>
export default {
    name: 'HorizontalLine'
}
</script>